module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-segment-visualisation-middle.e165e6bb.png";